import type { FlushResult } from "./types";

/**
 * Frozen empty flush result returned by `process()` when nothing was
 * applied (no load drained, no trims, no collapse-set delta). Reused
 * across cycles so repeated no-op cycles don't allocate.
 *
 * Module-private library constant — NOT re-exported from `src/index.ts`.
 */
export const EMPTY_FLUSH_RESULT: FlushResult = Object.freeze({
  stateChanged: false,
  trims: [],
  loads: [],
});
